import { state } from '@/store'
import { lego } from '@zz-common/lego'
import native from '@zz-common/native-adapter'
import { getQueryString } from '.'
import hybrid from './hybrid'

const asyncAdapter = (method: string, params: any, callback?: Function) => {
  if (Object.keys(params).length == 0) {
    return native.wrap(method)(callback)
  }
  return native.wrap(method)(params, callback && callback)
}

// 通知 webView pageId
export const setWebViewPageId = (params) => {
  asyncAdapter('setWebViewPageId', params)
}

//获取机型顶部状态栏高度
export const getStatusBarHeight = (params, callback) => {
  asyncAdapter('getStatusBarHeight', params, callback)
}
//设置顶部状态栏模式
export const setStatusBarDarkMode = (params: any, callback?: any) => {
  asyncAdapter('setStatusBarDarkMode', params, callback)
}
//判断是否登录
export const isLogin = () => {
  return native.isLogin()
}

//获取用户停留时长
export const getUserLengthOfStay = () => {
  const end_time = Number(new Date().getTime())
  const start_time = Number(localStorage.getItem('start_view'))
  const duration = end_time - start_time
  const infoId = getQueryString('infoId') || state.infoId
  if (duration > 0) {
    lego.send({
      pagetype: 'LengthOfStay',
      actiontype: 'T2974',
      backup: { infoId, eventduration: duration / 1000 }
    })
  }
}
//跳转
export const skipToUrl = (params, callback?: Function) => {
  // getUserLengthOfStay()
  asyncAdapter('skipToUrl', params, callback)
}

//登录
export const nativeLogin = (params) => {
  const insetCallback = params.callback
  params.callback = function (res) {
    if (!res) {
      return
    }
    insetCallback && insetCallback(res)
  }
  asyncAdapter('login', params)
}

//监听页面返回
export const RegisterPageCallback = (params) => {
  const insetCallback = params.callback
  params.callback = function (res) {
    if (!res) {
      return
    }
    insetCallback && insetCallback(res)
  }
  asyncAdapter('registerPageCallback', params)
}
//关闭当前页
export const pageClose = () => {
  // getUserLengthOfStay()
  return native.close()
}

//分享
export const pageShare = (params) => {
  asyncAdapter('shareClick', params)
}

// 小程序分享
export const waShare = (params) => {
  asyncAdapter('share', params)
}
//获取消息数量
export const getMsgCount = (params, callback) => {
  asyncAdapter('getAllUnreadCount', params, callback)
}
//判断所属平台
export const isPlatform = (Platform) => {
  return native.in(Platform) || false
}

//跳转到详情
export const skipToDetail = (params) => {
  // getUserLengthOfStay()
  asyncAdapter('skipToDetail', params)
}

//客户端跳转
export const enterUnifiedUrl = (params) => {
  asyncAdapter('enterUnifiedUrl', params)
}

export const playVideoBySystem = (params) => {
  asyncAdapter('playVideoBySystem', params)
}

export const enlargeImage = (params) => {
  asyncAdapter('enlargeImage', params)
}

//判断当前端内是否支持某个方法
export const hasSupportFeature = (params, callback) => {
  asyncAdapter('hasSupportFeature', params, callback)
}

//图片放大
export const browserLuxuryImages = (params, callback) => {
  asyncAdapter('browserLuxuryImages', params, callback)
}

//根据页面标识关闭页面
export const closeByMark = (params, callback) => {
  asyncAdapter('closeByMark', params, callback)
}

//图片放大
export const setKeyboardFrameChangeCallback = (callback) => {
  asyncAdapter('browserLuxuryImages', callback)
}

export const nativeGetCookie = (params, callback) => {
  asyncAdapter('getCookie', params, callback)
}

// $ 调起 native 收货地址选择
export const chooseAddress = (callback) => {
  native.chooseAddress({}, callback)
}

//页面展现
export const pageOnShow = (params, callback) => {
  hybrid.invoke('onShow', params, callback)
}

//页面隐藏
export const pageOnHide = (params, callback) => {
  hybrid.invoke('onHide', params, callback)
}

export const weChartPageOnShow = (callback) => {
  hybrid.invoke('onShow', callback)
}

//原生功能面板
export const showMoreDialog = (params, callback) => {
  asyncAdapter('showMoreDialog', params, callback)
}

/**
 * 客户端提供的存储能力，设置缓存
 * @key 缓存key
 * @value 缓存值
 * @expire 过期时间
 * @returns
 */
export const nativeSetStorage = async (key, value, expire = 3) => {
  native.setStoreItem('u', key, value, expire)
}

// 客户端提供的存储能力，获取缓存
export const nativeGetStorage = (key, callback) => {
  return native.getStoreItem('u', key, callback)
}

// 客户端提供的存储能力，删除缓存
export const nativeRemoveStoreItem = async (key, callback) => {
  native.removeStoreItem('u', key, callback && callback)
}

/**
 * $ 拉起图片验证码 registerSlider
 */
export const registerSlider = (params, callback) => {
  asyncAdapter('registerSlider', params, callback)
}

export const nativeToast = (params, callback) => {
  asyncAdapter('toast', params, callback)
}
